module.exports = __webpack_public_path__ + "static/media/m1bank_yout.e5be8bbf.png";